<template>
    <cms-block v-bind="$props" @block-selected="selectBlock">
        <span v-tr>Preview only|Aperçu seulement</span>
        <template v-if="currentMap">
            <b-img :src="currentMap.thumbnail"/>
        </template>
        <cms-component-image comp-id="bannerImage" :component="block.bannerImage" v-bind="componentProps"/>
    </cms-block>
</template>

<script>
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsComponentImage from "@/components/editor/rendering/components/cms-component-image.vue";
import MapMixin from "@/helpers/maps/map-mixin.js";

// cms-block-map #hot-reload-debug
/*
For Preview only, true render is done in cms-page-map
 */
export default {
    name: `cms-block-map`,
    components: {CmsComponentImage, CmsBlock},
    extends: CmsBlock,
    mixins: [MapMixin],
    mounted() {
        // this.map = this.currentMap;
        // this.$store.commit(`mapEditor/setMap`, this.map);
    }
}
</script>

<style lang="scss" scoped>
</style>
